/**
 * WalkieTalkieIcon — inline SVG used in the sidebar nav for the Radios row.
 *
 * Renders at any pixel size via the `size` prop. No external assets, no
 * CSS dependencies — drop it anywhere a small radio glyph is needed.
 */
interface WalkieTalkieIconProps {
  size?: number
}

export default function WalkieTalkieIcon({ size = 22 }: WalkieTalkieIconProps) {
  // Native viewBox is 48x90 (taller than wide). We give the SVG a square
  // bounding box of `size`x`size` and let preserveAspectRatio center it,
  // so it renders consistently across desktop and mobile browsers.
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 90"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <rect x="18" y="0" width="4" height="14" rx="2" fill="#888" />
      <rect x="6" y="22" width="36" height="64" rx="7" fill="#2d2d2d" />
      <rect x="10" y="26" width="28" height="18" rx="3" fill="#1a1a1a" />
      <circle cx="13" cy="48" r="1.5" fill="#22c55e" />
      <rect x="10" y="52" width="28" height="14" rx="2" fill="#0a1a0a" />
      <circle cx="24" cy="82" r="5" fill="#1a1a1a" />
      <rect x="39" y="30" width="3" height="26" rx="1.5" fill="#1a1a1a" />
      <rect x="39" y="44" width="7" height="4" rx="1.5" fill="#222" />
    </svg>
  )
}
